<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title eng="POINT TERMS OF SERVICE" :jpn="t('ポイント利用規約')" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">
              {{t('株式会社Iranoan（以下、「当社」といいます。）が提供するGacha24（以下、「本件サービス」といいます。）において「ポイント」（以下に定義します）を利用するにあたり、その利用に関する条件を定めるもの（以下、「ポイント利用規約」といいます。）です。')}}
            </span>
            <span class="text">
              {{t('十分にポイント利用規約の内容をご確認いただいた上で、ポイントのご購入をご検討ください。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('第1条 - 用語の定義')"
        >
          <div class="text-container">
            <span class="text">
              {{t('本件規約における以下の各号の用語の意味は、当該各号に定めるとおりとします。')}}
            </span>
            <span class="text">
              {{t('(1)「サービス利用契約」とは、本件サービスの利用に関する契約をいいます。')}}
            </span>
            <span class="text">
              {{t('(2)「サービス利用者」とは、当社とサービス利用契約を締結した者をいいます。')}}
            </span>
            <span class="text">
              {{t('(3)「アカウント情報」とは、サービス利用者が本件サービスに登録したサービス利用者に関する情報をいいます。')}}
            </span>
            <span class="text">
              {{t('(4)「ポイント」とは、本件サービス内でのみ利用可能なゲーム内仮想通貨をいいます。')}}
            </span>
            <span class="text">
              {{t('(5)「利用残高」とは、サービス利用者が保有し、利用することのできるポイントの残高となります。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('第2条 - ポイント')"
        >
          <div class="text-container">
            <span class="text">
              {{t('(1)サービス利用者は、当社所定の方法により、当社が本件サービス内で提示している金額で本件サービス内で使用可能なポイントを購入することができます。なお、当社は、サービス利用者に対して、ポイントの購入について購入単位、決済方法、利用期間その他の購入条件を設けることがあり、設定した購入条件及び支払可能金額等は、本件サービス又は当社の運営するサービス内に掲載します。')}}
            </span>
            <span class="text">
              {{t('(2)サービス利用者が当社所定の方法によりポイントの購入の意思表示を行った時点で、当該ポイントの購入に関するサービス利用者と当社の間の契約は成立し、購入にかかる総額が確定するものとします。')}}
            </span>
            <span class="text">
              {{t('(3)ポイントを購入するサービス利用者が未成年者である場合、当該サービス利用者はポイントの購入についてあらかじめ親権者の同意を得なければなりません。')}}
            </span>
            <span class="text">
              {{t('(4)当社は未成年者がポイントを購入した場合、親権者が当該ポイントの購入に同意したものとみなします。')}}
            </span>
            <span class="text">
              {{t('(5)本件サービス内に表示されているサービス利用者の利用残高は、アカウント情報に紐づいて本件サービス及び当社の運営する他のサービスの提供にかかる電気通信設備に記録されます。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('第3条 - ポイントの利用')"
        >
          <div class="text-container">
            <span class="text">
              {{t('(1)ポイントは、当社が本件サービス内の商品購入のために使用することができます。')}}
            </span>
            <span class="text">
              {{t('(2)サービス利用者は、ポイントの残高の範囲内で、当社が提供する商品を取得することができます。')}}
            </span>
            <span class="text">
              {{t('(3)サービス利用者が当社から商品を購入する際にポイントを使用した場合、ポイントの残高から商品の代金額を差し引くことにより、当該代金額の支払があったものとみなされます。なお、特段の定めがない場合、本件サービス内で当社からサービス利用者に対して無償で付与したポイントから優先的に消費されます。')}}
            </span>
            <span class="text">
              {{t('(4)サービス利用者は本件サービス内でポイントの残高を確認することができます。なお、サービス利用者はポイントの増減を自身の責任で管理し、確認するものとします。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('第4条 - ポイントの取り扱い')"
        >
          <div class="text-container">
            <span class="text">
              {{t('(1)当社は、本サービスにおいて利用者がポイントを購入した場合、当社がキャンペーンを実施する場合その他の場合に、当社の定める方法により、利用者にポイントを付与します。ポイントの購入単位、価格、有効期間、その他のポイントの付与条件は、当社が定め、本サービス上に表示します。')}}
            </span>
            <span class="text">
              {{t('(2)ポイントの有効期間は、ポイントが付与された日から6か月とします。')}}
            </span>
            <span class="text">
              {{t('(3)当社は、利用者が取得したポイントについて、法令上必要な場合を除き、一切払い戻しを行いません。法令に基づきポイントを払い戻す場合の払戻方法および条件は、別途当社が定める方法で掲示するものとします。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('第5条 - 換金行為の禁止等')"
        >
          <div class="text-container">
            <span class="text">
              {{t('本サービス内で取得した一切のコンテンツについては、直接、第三者による仲介又はインターネットオークション等その手段を問わず、売買その他、金銭その他現実世界における対価を授受する形でのあらゆる譲渡、譲受、貸与、借用等する行為（いわゆるRMT【リアルマネートレード】を含みますが、これに限られません。また、本サービス内におけるユーザーの行為に対して金銭その他、現実世界における対価を授受することも含みます。）を禁止いたします。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('第6条 - ポイントの譲渡等')"
        >
          <div class="text-container">
            <span class="text">
              {{t('サービス利用者は、ポイント及び商品を第三者に譲渡、貸与、贈与その他の移転や、質入れその他の担保権の設定をすることはできません。')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('第7条 - ポイントの購入及び利用の停止等')"
        >
          <div class="text-container">
            <span class="text">
              {{t('サービス利用者が以下に該当する場合、当社はサービス利用者に対して、当社が適当と判断する措置（ポイントの購入や利用の停止を含むがこれに限りません。）を実施できるものとします。')}}
            </span>
            <span class="text">
              {{t('(1)不正な方法によりポイントや商品を取得、利用した場合')}}
            </span>
            <span class="text">
              {{t('(2)サービス利用者が本件規約に違反した場合')}}
            </span>
            <span class="text">
              {{t('(3)その他、当社がサービス利用者の本件サービスの利用を不適切であると判断した場合')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">
              {{t('2021年11月10日 制定')}}
            </span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: #4a3f3a;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 360px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          // color: $white;
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
